<template>
  <div>
  </div>
</template>

<script>
  export default {
    name: 'Template',
    components: {
    },
    props: {
    },
    computed: {
    },

    mounted () {

    },
    data: () => ({

    }),
    methods: {



    },
    watch: {
      
    }
  }
</script>
